import { Button, Card, CardActions, CardHeader, Container, Stack, Typography } from "@bvhi/ui-base";
import { ArrowLeftIcon } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
import { getAppConfig } from "../../../config/config";

export const NotFoundView = () => {
  const { t } = useTranslation(["errors"]);

  return (
    <Container>
      <Stack pt={2} spacing={2}>
        <Card>
          <CardHeader
            title={t("errors:not.found.card.title")}
            subheader={
              <Typography>
                {t("errors:not.found.card.sub.title.1")}{" "}
                <a href={`mailto:${getAppConfig().env.supportMailAdesso}`}>{t("errors:not.found.card.sub.title.2")}</a>{" "}
                {t("errors:not.found.card.sub.title.3")}
              </Typography>
            }
          />

          <CardActions>
            <Button onClick={() => history.go(-1)} startIcon={<ArrowLeftIcon />}>
              {t("errors:error.card.button.back")}
            </Button>
          </CardActions>
        </Card>
      </Stack>
    </Container>
  );
};
